var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcRace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M680 207c15 0 28 13 28 28v211h180c6 0 12 1 16 5 13 8 16 26 7 39L682 822c-6 8-14 13-24 13-15 0-28-13-28-29V596H450c-6 0-12-2-16-5-13-9-16-27-8-39l230-333c6-7 14-12 24-12zM417 709c32 0 57 25 57 56s-25 57-57 57H218c-31 0-57-26-57-57s26-56 57-56h199zM300 483c31 0 57 25 57 57 0 31-26 56-57 56H140c-31 0-57-25-57-56 0-32 26-57 57-57h160zm117-226c32 0 57 26 57 57s-25 56-57 56H218c-31 0-57-25-57-56s26-57 57-57h199z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRace);
export default __webpack_public_path__ + "static/media/ic_race.9f179ca39cb9d587cece0d59f5055989.svg";
export { ForwardRef as ReactComponent };